import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { FilterAltIcon } from 'cokitchen-icons';
import { ENUM_POST_TYPES } from 'utils/enums';

type PostFilterDropdownProps = {
  setSelectedPostType: ({ id, name }: { id: string; name: string }) => void;
  selectedPostType: { id: string; name: string };
};

const postOptions = [
  { id: '', name: 'All Hompages posts' },
  { id: ENUM_POST_TYPES.FCB, name: 'FC Business' },
  { id: ENUM_POST_TYPES.FC, name: 'FoodCourt' },
  { id: ENUM_POST_TYPES.BUDGET, name: 'FC Budget' },
  { id: ENUM_POST_TYPES.SHOP, name: 'FC Shop' }
];

export default function PostFilterDropdown({
  setSelectedPostType: setSelectedFilter,
  selectedPostType
}: PostFilterDropdownProps) {
  const [show, setShow] = useState(false);
  return (
    <Dropdown
      placement='bottom'
      visible={show}
      onClickOutside={() => setShow(false)}
      content={
        <div
          onClick={() => setShow(!show)}
          className='cursor-pointer mb-2 flex items-center rounded-[40px] py-[9px] px-[18px] gap-1 bg-white hover:bg-gray-1 transition-all border'>
          <FilterAltIcon />
          <div className='max-w-[150px] text-sm whitespace-nowrap truncate'>
            {selectedPostType.name}
          </div>
        </div>
      }>
      <DropdownList>
        {postOptions?.map((option) => (
          <DropdownItem
            key={option.id}
            onClick={() => {
              setSelectedFilter(option);
              setShow(false);
            }}>
            <p className='text-gray-6 font-medium text-sm'>{option.name}</p>
          </DropdownItem>
        ))}
      </DropdownList>
    </Dropdown>
  );
}
